'use strict';

angular.module('internal.exams')
    .controller('ExamPacketRequirmentModalController', ['$scope', '$uibModalInstance', 'requirments', 'EXPackets', 'packetID', function ($scope, $uibModalInstance, requirments, EXPackets, packetID) {
        $scope.modalRequirments = requirments;
        $scope.name = "";
        $scope.minReqForms = 0;
        $scope.errorMessage = '';
        $scope.originalList = angular.copy(requirments);
        
        $scope.done = function () {
            $uibModalInstance.close($scope.modalRequirments);
        };

        $scope.removeRequirment = function (requirment) {
            $scope.modalRequirments.splice($scope.modalRequirments.indexOf(requirment), 1);
        };

        $scope.cancel = function () {
            $scope.modalRequirments = angular.copy($scope.originalList);
            $uibModalInstance.close($scope.modalRequirments);
        };

        $scope.addNew = function () {
            EXPackets.newPassingRequirment($scope.name, $scope.minReqForms, packetID).then(function (result) {
                if (result != null && result.error == null) {
                    var format = {
                        name: $scope.name, id: result.id, minPassedForms: $scope.minReqForms
                    };
                    $scope.modalRequirments.push(format);
                    $scope.name = "";
                    $scope.minReqForms = 0;
                }
                else {
                    $scope.errorMessage = result.error;
                }
            });
        };

    }]);